import { create } from 'zustand'

const useGeneralStore = create((set) => ({

    bears: 0,
    increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),

    //to track dark mode
    isDarkMode: true,
    setIsDarkMode: (value) => set({ isDarkMode: value }),

}))

export default useGeneralStore;